function isMobile() {
  return window.innerWidth <= 1089;
}

let lastIsMobile = isMobile();
let nextBtn, prevBtn, swipeArea;

function initializeDOMElements() {
  nextBtn = document.getElementById('nextBtn');
  prevBtn = document.getElementById('prevBtn');
  swipeArea = document.querySelector('.swipe-area');
}

function setupCardStack() {
  if (!isMobile()) {
    return { cards: [], nextBtn: null, prevBtn: null, swipeArea: null };
  }

  teardownCardStack();

  const cards = gsap.utils.toArray('[data-item]');
  if (!cards.length) {
    return { cards: [], nextBtn: null, prevBtn: null, swipeArea: null };
  }

  gsap.set(cards, {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
  });

  stackCards(cards);

  nextBtn?.addEventListener('click', () => onNextClick(cards, nextBtn));
  prevBtn?.addEventListener('click', () => onPrevClick(cards, prevBtn));

  swipeArea?.addEventListener('touchstart', (e) => onTouchStart(e));
  swipeArea?.addEventListener('touchend', (e) =>
    onTouchEnd(e, nextBtn, prevBtn)
  );

  return { cards, nextBtn, prevBtn, swipeArea };
}

function teardownCardStack() {
  const cards = gsap.utils.toArray('[data-item]');
  cards.forEach((card) => {
    gsap.killTweensOf(card);
    gsap.set(card, { clearProps: 'all' });
  });

  nextBtn?.removeEventListener('click', onNextClick);
  prevBtn?.removeEventListener('click', onPrevClick);
  swipeArea?.removeEventListener('touchstart', onTouchStart);
  swipeArea?.removeEventListener('touchend', onTouchEnd);
}

function onNextClick(cards, nextBtn) {
  if (nextBtn.disabled) return;
  disableBothButtons(nextBtn);

  const topCard = cards[0];

  gsap.set(topCard, { zIndex: cards.length + 100 });

  gsap
    .timeline({
      onComplete: () => {
        cards.push(cards.shift());
        gsap.set(topCard, { x: 0, y: 0, rotationY: 0 });
        stackCards(cards);
      },
    })
    .to(
      topCard,
      {
        x: 900,
        rotationY: 45,
        force3D: true,
        transformOrigin: 'left center',
        duration: 0.35,
        ease: 'expo.inOut',
      },
      0
    )
    .add(() => gsap.set(topCard, { zIndex: 0 }), 0.07);
}

function onPrevClick(cards, prevBtn) {
  if (prevBtn.disabled) return;

  disableBothButtons(prevBtn);

  const lastCard = cards.pop();
  cards.unshift(lastCard);

  gsap.set(lastCard, {
    x: 900,
    y: 0,
    rotationY: 45,
    zIndex: 0,
  });

  let hasUpdatedZ = false;

  gsap.to(lastCard, {
    x: 0,
    y: 0,
    rotationY: 0,
    force3D: true,
    opacity: 1,
    duration: 0.2,
    ease: 'power2.inOut',
    onUpdate: function () {
      if (!hasUpdatedZ && this.progress() > 0.4) {
        gsap.set(lastCard, { zIndex: cards.length + 100 });
        hasUpdatedZ = true;
      }
    },
    onComplete: () => stackCards(cards),
  });
}

function disableBothButtons(button) {
  button.disabled = true;

  setTimeout(() => {
    button.disabled = false;
  }, 600);
}

function stackCards(cards) {
  const offsetStep = 12;
  cards.forEach((card, index) => {
    gsap.set(card, {
      x: index * offsetStep,
      y: -index * offsetStep,
      zIndex: cards.length - index,
    });
  });
}

function onTouchStart(e) {
  e.target.dataset.touchStartX = e.changedTouches[0].screenX;
}

function onTouchEnd(e, nextBtn, prevBtn) {
  const touchStartX = e.target.dataset.touchStartX || 0;
  const diff = e.changedTouches[0].screenX - touchStartX;
  if (Math.abs(diff) > 50) (diff > 0 ? nextBtn : prevBtn)?.click();
}

function observeSwipeArea() {
  if (isMobile()) return;

  const target = document.querySelector('.list.swipe-area');
  if (!target || target.classList.contains('is-visible')) return;

  const items = target.querySelectorAll('.item[data-item]');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          items.forEach((item, index) => {
            item.style.setProperty('--delay', `${index * 0.15}s`);
          });
          target.classList.add('is-visible');
          observer.disconnect();
        }
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(target);

  if (target.getBoundingClientRect().top < window.innerHeight) {
    items.forEach((item, index) => {
      item.style.setProperty('--delay', `${index * 0.15}s`);
    });
    target.classList.add('is-visible');
    observer.disconnect();
  }
}

function handleResizeForAnimation() {
  const isNowMobile = isMobile();

  if (isNowMobile && !lastIsMobile) {
    setupCardStack();
  } else if (!isNowMobile && lastIsMobile) {
    teardownCardStack();

    const target = document.querySelector('.list.swipe-area');
    if (target) {
      target.classList.remove('is-visible');
      target.querySelectorAll('.item[data-item]').forEach((item) => {
        item.removeAttribute('style');
      });
    }

    observeSwipeArea();
  }

  lastIsMobile = isNowMobile;
}

document.addEventListener('DOMContentLoaded', () => {
  initializeDOMElements();
  const { cards, nextBtn, prevBtn, swipeArea } = setupCardStack();
  handleResizeForAnimation();

  if (!isMobile()) {
    observeSwipeArea();
  }
});

$(window).on('resize', () => {
  let resizeTimeout;
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    handleResizeForAnimation();
  }, 150);
});
